/* src/app/dialogs/article-picker/article-picker.component.css */
.row > div > .mat-mdc-card {
  margin-bottom: 15px;
}
/*# sourceMappingURL=article-picker.component-WWOV4OGD.css.map */
